import { useState } from 'react';
import { EvScreen } from '../../evscreen/EVScreen/evScreen';
import { OnboardingShell } from '../OnboardingShell';

export const TourStep = (props) => {
	const { stepIndex, totalSteps, onBack, filtersOpen, setFiltersOpen } = props;
	const [tourStarted, setTourStarted] = useState(false);

	return (
		<OnboardingShell
			stepIndex={stepIndex}
			totalSteps={totalSteps}
			onBack={onBack}
			showBack={!!onBack}
			hideFooter={true}
			fullBleed={true}
			hideChrome={tourStarted}>
			<EvScreen
				tutorial={true}
				filtersOpen={filtersOpen}
				setFiltersOpen={setFiltersOpen}
				onVideoClose={() => setTourStarted(true)}
			/>
		</OnboardingShell>
	);
};
